export const BASE_TOOLTIP_CLASSES =
  'z-[10000010] w-[350px] rounded-sm border border-slate-200 bg-white p-2 text-sm text-slate-900 shadow-lg';
